import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/library/accordion";
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import NavLinkItem from "./SideBarNavItem";
import { Route } from "@/types/general";

export default function SideBarAccordanItem({
  section,
  alwaysOpen = false,
}: {
  section: any;
  /** Pinned-open section (MODULE / CONFIGURATIONS): header is inert, no chevron. */
  alwaysOpen?: boolean;
}) {
  // A section with no label has no header to click, so it is not an accordion
  // at all — render its items plainly and always expanded. Wrapping it in an
  // AccordionItem keyed on "" would collide with any other headerless group
  // and make them collapse together.
  if (!section.label) {
    return (
      <SidebarGroup className="transition-[padding] duration-200 ease-linear">
        <SidebarGroupContent className="transition-all duration-200 ease-linear">
          <SidebarMenu className="transition-all duration-200 ease-linear">
            <SidebarMenuItem>
              <div className="pl-4 flex flex-col gap-y-1">
                {section.routes.map((route: Route) => (
                  <NavLinkItem route={route} key={route.path} />
                ))}
              </div>
            </SidebarMenuItem>
          </SidebarMenu>
        </SidebarGroupContent>
      </SidebarGroup>
    );
  }

  return (
    <AccordionItem
      key={section.label}
      value={section.label}
      className="border-b-0"
    >
      <SidebarGroup className="transition-[padding] duration-200 ease-linear">
        <SidebarGroupContent className="transition-all duration-200 ease-linear">
          <SidebarMenu className="transition-all duration-200 ease-linear">
            <SidebarMenuItem>
              <AccordionTrigger
                disabled={alwaysOpen}
                showIcon={!alwaysOpen}
                className={`flex items-center justify-start py-2 px-3 text-b5 tracking-wide text-[var(--color-black-6)] uppercase hover:no-underline data-[state=open]:text-b4 data-[state=open]:tracking-wide data-[state=open]:text-[var(--color-black-6)]${
                  alwaysOpen ? " disabled:opacity-100" : ""
                }`}
              >
                <span
                  className="ml-0 mr-auto text-inherit"
                  style={{ letterSpacing: ".1rem", fontSize: "12px" }}
                >
                  {section.title ?? section.label}
                </span>
              </AccordionTrigger>

              {/* AccordionContent wraps the submenu items */}
              <AccordionContent className="pt-0 pb-0 transition-all duration-200 ease-linear">
                {/* Added 'flex flex-col gap-y-1' for vertical spacing */}
                <div className="pl-4 flex flex-col gap-y-1">
                  {section.routes.map((route: Route) => (
                    <NavLinkItem route={route} key={route.path} />
                  ))}
                </div>
              </AccordionContent>
            </SidebarMenuItem>
          </SidebarMenu>
        </SidebarGroupContent>
      </SidebarGroup>
    </AccordionItem>
  );
}
